import type { FaireProductEntity } from "../../entity_types/product";

export const p_t8nw8a5hpm: FaireProductEntity = {
  token: "p_t8nw8a5hpm",
  type: "product",
  name: "Avisa Cake Stand-Sage Green, 9.44 Inches",
  brandToken: "b_9f715f8d",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/21517402b55013b206ae05fcefca3933d37258243b93707d314c04fd72f03d54.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8c2e19ac914584b783aeef41e8b64b1fb3b34ad202c6379a256322f895cab43b.jpeg",
    "https://cdn.faire.com/fastly/8567226e9bad6203b1e11f756a246343ca9ce29691b5ec7ec9675ff76a69690f.jpeg",
    "https://cdn.faire.com/fastly/e8302ccce109b31e25dfcd6712eed4d7896b1ec5662e9fd3fd2702f847c1d828.jpeg",
    "https://cdn.faire.com/fastly/0d7907797a7de754135594dcb333a7780eb3e6efc1f6e3e27db67bab4e835103.jpeg",
  ],
  priceDollars: 50,
  description:
    "If you're looking for a stylish and functional way to display your baked goods, look no further than the Avisa Cake Stand. This stunning cake stand is the perfect addition to any kitchen decor and will instantly add a touch of elegance to your home. Made from high-quality materials, this cake stand is not only beautiful but also durable and long-lasting.\n\nIt's also easy to clean and can be wiped down with a damp cloth.\n\n\nThe Avisa cake stands come in soft colors and feature a minimalistic ribbed pattern at the bottom, adding an element of elegance to your tables.\nThe Avisa cake stands come in soft colors and feature a minimalistic ribbed pattern at the bottom, adding an element of elegance to your tables. These are lightweight, durable, and perfect for serving all your desserts and snacks.\n\n• Material - Iron with powder coating\n• Size- 9.44 Inches\n• Hand Made in India\n• Hand-wash with a soft sponge and mild detergent, avoid the use of abrasives. Do not scrub. Do not use in the dish\n\n\nPreorder- To ship 7th June 2025\n",
  tags: [],
  msrpDollars: 100,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:33.864Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
